__turbopack_context__.v({
  "action": "FounderInvite-module__E21gcq__action",
  "body": "FounderInvite-module__E21gcq__body",
  "invite": "FounderInvite-module__E21gcq__invite",
  "title": "FounderInvite-module__E21gcq__title",
});
